/*
 * Capable Health API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v0.3
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.72
 *
 * Do not edit the class manually.
 *
 */
import ApiClient from '../ApiClient';
import PractitionersinvitePractitioner from './PractitionersinvitePractitioner';

/**
 * The PractitionersInviteBody model module.
 * @module model/PractitionersInviteBody
 * @version v0.3
 */
export default class PractitionersInviteBody {
  /**
   * Constructs a new <code>PractitionersInviteBody</code>.
   * @alias module:model/PractitionersInviteBody
   * @class
   */
  constructor() {
  }

  /**
   * Constructs a <code>PractitionersInviteBody</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/PractitionersInviteBody} obj Optional instance to populate.
   * @return {module:model/PractitionersInviteBody} The populated <code>PractitionersInviteBody</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new PractitionersInviteBody();
      if (data.hasOwnProperty('practitioner'))
        obj.practitioner = PractitionersinvitePractitioner.constructFromObject(data['practitioner']);
    }
    return obj;
  }
}

/**
 * @member {module:model/PractitionersinvitePractitioner} practitioner
 */
PractitionersInviteBody.prototype.practitioner = undefined;

